import React from 'react';
import Elevate2025  from 'views/Elevate2025';

const ExtraCurricularActivitiesPage = () => {
  return <Elevate2025 />;
};

export default ExtraCurricularActivitiesPage;